<template>
  <div>
    <custom-actions>
      <el-form inline :model="searchForm" ref="searchForm" class="global-form-label-width">

        <el-form-item label="供应商" prop="supplierName">
          <el-input v-model="searchForm.supplierName" placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="品种规格" prop="specName">
          <el-input v-model="searchForm.specName" placeholder="请输入品种规格"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="供应商" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="规格单位" prop="specXh"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="订单数量" prop="purchaseQuantity"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="已提数量" prop="deliveryQty"></el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'QuantityCount',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        supplierName: null,
        specName: null
      }
    }
  },
  computed: {

  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.purchaseOrders.selectYcnPurchaseSpecByList, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },

    deleteRow(invoiceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseInvoice.deleteYcInvoice, {
          invoiceId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
